import React, { useState, useEffect, useContext } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Form, Button, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader.js'
import FormContainer from '../components/FormContainer.js'
import { getUserDetails, updateUser } from '../actions/adminActions.js'
import { ADMIN_UPDATE_USER_RESET } from '../constants/adminConstants.js'
import { ThemeContext } from '../components/ThemeContext.js'

const UserEditScreen = () => {
  const { theme } = useContext(ThemeContext)
  const params = useParams()
  const userId = params.id

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isAdmin, setIsAdmin] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [message, setMessage] = useState(null)

  const [masterload, setMasterLoad] = useState(true)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const adminGetUser = useSelector((state) => state.adminGetUser)
  const { user, loading, error } = adminGetUser

  const adminUpdateUser = useSelector((state) => state.adminUpdateUser)
  const { success: successUpdate } = adminUpdateUser

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: ADMIN_UPDATE_USER_RESET })
      navigate('/userlist')
    } else {
      if (!user || successUpdate) {
        dispatch(getUserDetails(userId))
      } else if (user && masterload) {
        dispatch(getUserDetails(userId))
        setMasterLoad(false)
      } else {
        setName(user.name)
        setEmail(user.email)
        setIsAdmin(user.isAdmin)
        setIsDisabled(user.isDisabled)
      }
    }
  }, [dispatch, navigate, userId, user, masterload, successUpdate])

  const submitHandler = (e) => {
    e.preventDefault()

    setMessage(null)

    if (password === '') {
      setMessage('Password cannot be empty')
      return
    }

    if (password !== confirmPassword) {
      setMessage('Passwords do not match')
      setPassword('')
      setConfirmPassword('')
      return
    }

    if (password.length < 6 || confirmPassword.length < 6) {
      setMessage('Password must be at least 6 characters long')
      setPassword('')
      setConfirmPassword('')
      return
    }

    if (password === confirmPassword && password !== '') {
      setMessage('Password Updated Successfully')
    }

    dispatch(
      updateUser({
        _id: userId,
        name,
        email,
        password,
        isAdmin,
        isDisabled
      })
    )

    setPassword('')
    setConfirmPassword('')
  }

  return (
    <>
      <Button
        as={Link}
        to='/userlist'
        className='my-2'
        variant='outline-primary'
        style={{
          borderColor: theme.accent,
          color: theme.accent,
          backgroundColor: 'transparent'
        }}
      >
        Go Back
      </Button>
      <FormContainer>
        <h1>Edit User</h1>
        {message && password !== confirmPassword && (
          <Alert variant='danger' dismissible onClose={() => setMessage(null)}>
            {message}
          </Alert>
        )}

        {message && password === confirmPassword && password !== '' && (
          <Alert variant='success' dismissible onClose={() => setMessage(null)}>
            {message}
          </Alert>
        )}

        {message && password === '' && (
          <Alert variant='warning' dismissible onClose={() => setMessage(null)}>
            {message}
          </Alert>
        )}
        {loading ? (
          <Loader />
        ) : error ? (
          <Alert variant='danger' dismissible onClose={() => setMessage(null)}>
            {error}
          </Alert>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group className='mb-2' controlId='name'>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type='name'
                placeholder='Enter name'
                value={name}
                onChange={(e) => setName(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group className='mb-2' controlId='email'>
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type='email'
                placeholder='Enter email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group className='mb-2' controlId='password'>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='Enter password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className='mb-2' controlId='confirmPassword'>
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='Confirm password'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className='mb-2' controlId='isadmin'>
              <Form.Check
                type='checkbox'
                label='Is Admin'
                checked={isAdmin}
                onChange={(e) => setIsAdmin(e.target.checked)}
              ></Form.Check>{' '}
            </Form.Group>

            <Form.Group className='mb-2' controlId='isdisabled'>
              <Form.Check
                type='checkbox'
                label='Is Disabled'
                checked={isDisabled}
                onChange={(e) => setIsDisabled(e.target.checked)}
              ></Form.Check>
            </Form.Group>
            <Button
              type='submit'
              variant='outline-primary'
              style={{
                borderColor: theme.accent,
                color: theme.accent,
                backgroundColor: 'transparent'
              }}
            >
              Update
            </Button>
          </Form>
        )}
      </FormContainer>
    </>
  )
}

export default UserEditScreen
